import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useEnumApi } from "contexts/EnumApiContext";

const ConstantInspectionListTable = ({equipmentAlerts, setIsLoading}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    const goLink = (id) => {
        //let linkUrl = '../'+equipmentAlerts[i].id+window.location.search;
        console.log(id);
        setIsLoading(false);
        document.location.href = '/equipment-alert-history-tracking/'+id+window.location.search;
    }

    return (
        <>
            <div style={{marginBottom:"10px"}}>
                <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                <Chip label={t('menu.cmms.equipment-alert-history-tracking')} color="primary" />
            </div>
            
            <TableContainer>
                <Table aria-label="simple table" className="list_table">
                <TableHead>
                    <TableRow>
                        <TableCell className="th" align="center">{t('message.common.subtitle.fllwActionType')}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.dateAt')}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.alertType')}</TableCell>
                        <TableCell className="th" align="center">{t('message.common.subtitle.alertCategory')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {equipmentAlerts && equipmentAlerts.map(function(alert,i) {
                    //let linkUrl = '/management/maintenance/tracking/'+alert.id+window.location.search;
                    let statusColor = "";
                    if (alert.fllwActionType) {
                        if (alert.fllwActionType === 'O1_WAIT') {
                            statusColor = "condition1";
                        } else if (alert.fllwActionType === 'O4_NORMAL') {
                            statusColor = "condition6";
                        } else if (alert.fllwActionType === 'O2_OBSERVE') {
                            statusColor = "condition3";
                        } else if (alert.fllwActionType === 'O3_MNT') {
                            statusColor = "condition5";
                        }
                    }
                    return (
                    <TableRow key={i}>
                        <TableCell className={statusColor}><span style={{cursor:"pointer"}} onClick={()=>{goLink(alert.id)}}>{alert.fllwActionType && getEnumValueByEnumNameAndCode("FollowActionType", alert.fllwActionType) && getEnumValueByEnumNameAndCode("FollowActionType", alert.fllwActionType)[0].title}</span></TableCell>
                        <TableCell><span style={{cursor:"pointer"}} onClick={()=>{goLink(alert.id)}}>{dayjs(alert.latestAlertedAt).format("YYYY-MM-DD HH:mm")}&nbsp;</span></TableCell>
                        <TableCell><span style={{cursor:"pointer"}} onClick={()=>{goLink(alert.id)}}>{alert.alertType && getEnumValueByEnumNameAndCode("AlertType", alert.alertType) && getEnumValueByEnumNameAndCode("AlertType", alert.alertType)[0].title}</span></TableCell>
                        <TableCell><span style={{cursor:"pointer"}} onClick={()=>{goLink(alert.id)}}>{alert.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", alert.alertCategory) && getEnumValueByEnumNameAndCode("AlertCategory", alert.alertCategory)[0].title}</span></TableCell>
                    </TableRow> 
                    )
                    })}
                </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default ConstantInspectionListTable;